<template>
    <div class="w-100 h-100 sign-in-mobile" v-show="ready">
        <div class="w-100 h-100" v-if="$organization.sso"><i class="el-icon-loading"></i></div>
        <div v-else>
            <div class="container align-items-center pt-3 border-bottom">
                <div class="logo">
                    <img :src="'/assets/shanghaitech/images/single-logo.png'" alt="logo">
                    <span class="page-title"> {{ preset.app.name || '视频会议系统' }}</span>
                    <div class="pull-right mt-3  d-lg-block d-none">
                        <digital-clock shanghaitech></digital-clock>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="navbar-shanghaitech">
                    <nav class="my-3">
                        <a class="p-2 m-2 text-black font-weight-bold " v-for="(x,i) in menus" :key="i"
                           @click="tab_index=i" :class="{active:tab_index === i}">{{ x }}</a>
                    </nav>
                </div>
            </div>
        </div>
        <div class="page-body-wrap" style="height:493px;overflow: hidden;margin-bottom: 20px;">
            <div class="page-body" v-if="tab_index === 0">
                <el-carousel indicator-position="inside" height="493px" :interval="30000">
                    <el-carousel-item v-for="item in background_images" :key="item">
                        <div class="carousel-image" :style="{'background-image':'url('+item+')'}"></div>
                    </el-carousel-item>
                </el-carousel>
                <div class="body-wrap">
                    <div class="login">
                        <div class="container h-100">
                            <div class="slogan-wrap">
                                <div class="slogan-box">
                                    <div class="slogan" v-for="(x,i) in slogan" :key="i">{{ x }}</div>
                                    <div class="w-100 d-flex mt-5">
                                        <el-button type="danger" class="w-100"
                                                   @click="jumpToOAuth2" style="font-size:20px;" icon="el-icon-link">
                                            统一身份认证
                                        </el-button>
                                        <!--<el-button type="danger" @click="show_login=true" style="font-size:14px; width: 60px;" circle>本地</el-button>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="body-wrap" v-if="show_login">
                    <div class="login">
                        <div class="login-wrap">
                            <div class="login-bg">
                                <div class="login-table">
                                    <div class="text-center login-title position-relative">
                                        登 录 | SIGN IN
                                    </div>
                                    <div class="line"></div>
                                    <form class="clearfix" action="/" @submit.prevent="submitForm" v-if="admin_login">
                                        <div class="login-group">
                                            <div class="login-icon shanghaitech"><i class="fa fa-envelope"></i> &nbsp;
                                            </div>
                                            <div class="login-input-wrap">
                                                <input type="text" v-model="login.id"
                                                       placeholder="用户/邮箱" class="login-input" required/>
                                            </div>
                                        </div>

                                        <div class="login-group mt-2">
                                            <div class="login-icon shanghaitech"><i class="fa fa-lock"></i> &nbsp;</div>
                                            <div class="login-input-wrap">
                                                <input type="password" v-model="login.password"
                                                       placeholder="密码" class="login-input" required>
                                            </div>
                                        </div>

                                        <div class="text-right mb-3">
                                            <a href="javascript:void(0);">
                                                <small>使用用户名和密码登录</small>
                                            </a>
                                        </div>
                                        <div>
                                            <button type="submit" class="login-btn btn btn-block"
                                                    :disable="process.loading"
                                                    style="font-size:20px;">登 录
                                            </button>
                                        </div>

                                        <div class="text-left mt-2">
                                            <el-button type="text" @click="admin_login=false">
                                                统一身份认证
                                            </el-button>
                                        </div>
                                    </form>
                                    <div v-if="!admin_login" class="flex-in-middle" style="height: 240px;">
                                        <div class="" style="height: 1px"></div>
                                        <div class="w-100">
                                            <button type="button" class="login-btn btn btn-block"
                                                    :disable="process.loading"
                                                    @click="jumpToOAuth2" style="font-size:20px;">
                                                <i class="el-icon-user"></i> 统一身份认证
                                            </button>
                                            <div style="font-size:13px;text-align: center;margin-top: 20px;"
                                                 class="text-muted">点击按键,跳转到 <b>统一身份认证</b>
                                            </div>
                                        </div>
                                        <div class="w-100 text-center">
                                            <el-button type="text" @click="admin_login=true">用户口令登录</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-body" v-if="tab_index === 1" style="background-color:  white">
                <div class="container py-1">
                    <div class="d-flex mt-4">
                        <div class="text-nowrap mr-3" style="line-height: 40px; font-size: 19px;">请输入会议号:</div>
                        <el-input v-model="meeting_number" placeholder="请输入腾讯会议号" clearable
                                  style="width: 15em"></el-input>
                    </div>
                    <div class="text-muted mt-3" style="font-size: 16px;">腾讯会议号由9-13数字组成。</div>
                    <div class="mt-5">
                        <el-button type="primary" icon="el-icon-link" @click="joinTencentMeeting">加入腾讯会议</el-button>
                    </div>
                </div>
            </div>
            <div class="page-body" v-if="tab_index === 2" style="background-color: white">
                <div class="container mt-3">
                    <div style="font-size: 19px;" class="pt-3">腾讯会议全面支持多种桌面客户端</div>
                    <div class="d-flex mt-5" style="justify-content: space-around; flex-wrap: wrap">
                        <div v-for="x in tencent_downloads" :key="x.id" style="cursor: pointer;"
                             @click="handleTencentDownload">
                            <div style="width: 128px;height: 128px;background-size: contain"
                                 :style="{backgroundImage:'url('+x.icon+')'}"></div>
                            <div class="text-center">{{ x.title }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-body" v-if="tab_index === 3" style="background-color: white">
                <div class="container mt-3">
                    <div style="font-size: 19px;" class="pt-3">查看使用手册</div>
                    <ul class="mt-3 manual-list">
                        <li v-for="item in manuals" :key="item.name" style="line-height: 30px;">
                            <a :href="item.link" target="_blank"><i :class="item.icon"></i> {{ item.name }} </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="container mb-3 pt-4" v-if="tab_index === 0">
            <el-row class="function" gutter="30">
                <el-col v-for="x in icons" :key="x.icon" :span="12">
                    <div class="function-body mb-4">
                        <h3 class="card-title feature-title " :class="x.icon">{{ x.subject }}</h3>
                        <p class="card-text">{{ x.title }}</p>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="page-footer">
            <div class="container pt-3 border-top" style="font-size: 14px;">
                版权所有 © 2022 上海科技大学沪ICP备13001436号 <br/>
                联系我们 TEL：021-20685566 <br> &nbsp;&nbsp;Email：it-support@shanghaitech.edu.cn
            </div>
        </div>

        <el-dialog append-to-body width="50%" title="错误" :visible.sync="show_login_error"
                   :close-on-click-modal="false" v-mobile-dialog>

            <el-row :gutter="20">
                <el-col :span="24">
                    <div v-html="error_message"></div>
                </el-col>
            </el-row>
            <div slot="footer" class="">
                <el-button type="primary" @click="jumpToSignIn">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import "@/scss/sign-in.scss";
import SignIn from "@/views/mixins/sign-in"
import SignInShanghaitechMixin from "@/views/mixins/sign-in-shanghaitech-mixin";
import CommonMixin from "@/common/mixins/common-mixin";
import "@/views/scss/shanghaitech-sign-in.scss";

export default {
    mixins: [SignIn, SignInShanghaitechMixin, CommonMixin],
    components: {},
}
</script>

